export default __webpack_public_path__ + "static/media/slide9.7c33c3ae.png";